import { defineComponent } from 'vue';
import { useEmptyStringFormat } from '@/hooks/fn';
export default defineComponent({
  name: 'BudgetItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props, ctx) {
    var emptyStringFormat = useEmptyStringFormat();
    return {
      emptyStringFormat: emptyStringFormat
    };
  }
});